import React from 'react';
import WishlistReminderPopup from './WishlistReminderPopup';
import CartReminderPopup from './CartReminderPopup';
import { useReminderPopups } from '../hooks/useReminderPopups';

/**
 * Component to manage reminder popups.
 * Must be rendered inside WishlistProvider and Redux Provider.
 */
const ReminderPopupsManager = () => {
  const {
    showWishlistPopup,
    showCartPopup,
    dismissWishlistPopup,
    dismissCartPopup,
  } = useReminderPopups();

  return (
    <>
      {showWishlistPopup && (
        <WishlistReminderPopup onClose={dismissWishlistPopup} />
      )}
      {showCartPopup && (
        <CartReminderPopup onClose={dismissCartPopup} />
      )}
    </>
  );
};

export default ReminderPopupsManager;

